import { Controller } from "@hotwired/stimulus";
import { syncSectionDiagram } from "../../helpers/section_diagram.js";

// Connects to data-controller="sanitation-forms--form-component"
export default class extends Controller {
  static targets = [
    "openEndedCheckbox",
    "openEndedSamplesCheckbox",
    "lotTreePercentageInput",
    "samplesPerTreeSectionInput",
    "sectionsInput",
    "diagramVariant",
    "diagramFallback",
  ];

  connect() {
    this.updateDiagram();
  }

  updateDiagram() {
    if (!this.hasSectionsInputTarget) return;

    const parsed = parseInt(this.sectionsInputTarget.value, 10);
    const count = Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    syncSectionDiagram(this.diagramVariantTargets, this.diagramFallbackTargets, count);
  }

  toggleOpenEnded() {
    if (this.openEndedCheckboxTarget.checked) {
      this.lotTreePercentageInputTarget.value = null;
      this.lotTreePercentageInputTarget.disabled = true;
    } else {
      this.lotTreePercentageInputTarget.disabled = false;
    }
  }

  toggleOpenEndedSamples() {
    if (this.openEndedSamplesCheckboxTarget.checked) {
      this.samplesPerTreeSectionInputTarget.value = 0;
      this.samplesPerTreeSectionInputTarget.disabled = true;
    } else {
      this.samplesPerTreeSectionInputTarget.value = 1;
      this.samplesPerTreeSectionInputTarget.disabled = false;
    }
  }
}
